import { useAppSelector } from "@/hooks/useAppSelector";
import { ChartContainer, ChartTooltip } from "@/components/ui/chart";
import { BarChart, Bar, XAxis, YAxis } from "recharts";

export const CategoryDistributionGraph = () => {
  const { companies } = useAppSelector(state => state.supaCompanies);

  // Process companies data to count categories
  const categoryData = companies.reduce((acc: { [key: string]: number }, company) => {
    if (company.category) {
      acc[company.category] = (acc[company.category] || 0) + 1;
    }
    return acc;
  }, {});

  // Convert to array format for Recharts
  const chartData = Object.entries(categoryData)
    .map(([category, count]) => ({
      category,
      count
    }))
    .sort((a, b) => b.count - a.count); // Sort by count in descending order

  return (
    <div className="bg-white p-6 rounded-lg shadow-sm">
      <h3 className="text-lg font-semibold mb-4 text-black">Company Categories Distribution</h3>
      <div className="flex flex-col items-start w-full">
        <div className="w-full h-[400px]">
          <ChartContainer
            config={{
              bar: {
                theme: {
                  light: "#3b82f6",
                  dark: "#3b82f6",
                },
              },
            }}
          >
            <BarChart 
              data={chartData} 
              margin={{ top: 20, right: 30, left: 30, bottom: 120 }}
            >
              <XAxis
                dataKey="category"
                tick={{ fill: '#000000', fontSize: 12 }}
                stroke="#000000"
                angle={-45}
                textAnchor="end"
                interval={0}
              />
              <YAxis
                tick={{ fill: '#000000', fontSize: 12 }}
                stroke="#000000"
                label={{ 
                  value: 'Number of Companies', 
                  angle: -90, 
                  position: 'insideLeft', 
                  fill: '#000000'
                }}
              />
              <Bar 
                dataKey="count" 
                fill="#3b82f6"
                radius={[4, 4, 0, 0]} 
              />
              <ChartTooltip />
            </BarChart>
          </ChartContainer>
        </div>
      </div>
    </div>
  );
};